import { render, staticRenderFns } from "./AllowancesPlanDelete.vue?vue&type=template&id=0d55a3fe&scoped=true&"
import script from "./AllowancesPlanDelete.vue?vue&type=script&lang=js&"
export * from "./AllowancesPlanDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d55a3fe",
  null
  
)

export default component.exports